import {
    FETCH_USER
} from '../actions/types';

const INITIAL_STATE = {
    loading: false,
    error: false,
    error_message: ''
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_USER:
            return {
                ...state
            };

        default:
            return {
                ...state
            };
    };
};